// Centralized constants for the landing page

export const LANDING_LAYOUT = {
  NAV_HEIGHT: 56,
  MOBILE_MENU_WIDTH: 280,
  MOBILE_MENU_ANIMATION_DELAY: 300,
  Z_INDEX: {
    CONTENT: 10,
    COOKIE_CONSENT: 40,
    NAVIGATION: 50,
  }
} as const;

export const DECORATIVE_BLOBS = {
  SIZES: {
    SMALL: 300,
    MEDIUM: 400,
    LARGE: 500,
  },
  POSITIONS: [
    { top: 'top-20', right: 'right-10', size: 300 },
    { bottom: 'bottom-20', left: 'left-10', size: 400 },
    { top: 'top-40', left: 'left-1/4', size: 500 },
  ]
} as const;

export const VALID_REDIRECT_PATHS = ['/orders', '/dashboard', '/archive'] as const;
